export const notSetOption = { id: "not_set", label: "Not set" };

export const yesNoOptions = [
  notSetOption,
  { id: "yes", label: "Yes" },
  { id: "no", label: "No" },
];

export const billingFrequencyOptions = [
  notSetOption,
  { id: "ONE_TIME", label: "One time" },
  { id: "MONTHLY", label: "Monthly" },
];

export const serviceType = {
  REGULAR: { id: "REGULAR", label: "Regular" },
  RENTAL: { id: "RENTAL", label: "Rental" },
  SERVICE_FEE: { id: "SERVICE_FEE", label: "Service fee" },
  SERVICE_FEE_REDUCED_TAX: {
    id: "SERVICE_FEE_REDUCED_TAX",
    label: "Service fee (10% tax)",
  },
  FINAL_CLEANING: { id: "FINAL_CLEANING", label: "Final cleaning" },
  CITY_TAX: { id: "CITY_TAX", label: "City tax" },
};

export const serviceTypeOptions = [
  notSetOption,
  serviceType.REGULAR,
  serviceType.RENTAL,
  serviceType.SERVICE_FEE,
  serviceType.SERVICE_FEE_REDUCED_TAX,
  serviceType.FINAL_CLEANING,
  serviceType.CITY_TAX,
];

export const systemRoles = {
  ADMIN: "ROLE_ADMIN",
  USER: "ROLE_USER",
  SALES: "ROLE_SALES",
  HOUSEKEEPING: "ROLE_HOUSEKEEPING",
};
